import { Node } from "@iventis/domain-model/model/node";
import { NodeType } from "@iventis/domain-model/model/nodeType";
import { findNode } from "@iventis/tree-browser";

export const FOLDER_LIKE_NODE_TYPES: readonly NodeType[] = [NodeType.Folder, NodeType.Stream, NodeType.Stage, NodeType.StreamLayerGroup, NodeType.DayLayerGroup];
/** Groups the relay creates and manages, so neither they nor anything inside them can be renamed, moved, copied or deleted from the sidebar */
export const RELAY_CONTAINER_NODE_TYPES: readonly NodeType[] = [NodeType.Stream, NodeType.Stage, NodeType.StreamLayerGroup, NodeType.DayLayerGroup];

export const isFolderLikeNodeType = (type: NodeType): boolean => FOLDER_LIKE_NODE_TYPES.includes(type);
export const isRelayContainerNodeType = (type: NodeType): boolean => RELAY_CONTAINER_NODE_TYPES.includes(type);

export const isInsideRelayContainer = (tree: Node, node: Node): boolean => {
    if (node == null || tree == null) {
        return false;
    }
    let current = findNode([tree], node.parentId);
    while (current != null) {
        if (isRelayContainerNodeType(current.type)) {
            return true;
        }
        current = findNode([tree], current.parentId);
    }
    return false;
};

export const isRelayContainerOrDescendant = (tree: Node, node: Node): boolean => {
    if (node == null) {
        return false;
    }
    return isRelayContainerNodeType(node.type) || isInsideRelayContainer(tree, node);
};

/** Layers in a plan's non-relay layers group have no relay data fields, so their place in the tree is what marks them as made by the relay */
export const isInNonRelayLayersGroup = (tree: Node, node: Node) => node != null && tree != null && findNode([tree], node.parentId)?.type === NodeType.DayLayerGroup;
